export const focusAndMoveCaret = (element: HTMLElement): void => {
  element.focus()

  if (window.getSelection && document.createRange) {
    const range = document.createRange()
    range.selectNodeContents(element)
    range.collapse(false)
    const selection = window.getSelection()!
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

export enum appENV {
  localhost = 'localhost',
  development = 'development',
  test = 'test',
  production = 'production',
}

export function checkWindowLocation(): appENV {
  const splitUri = window.location.hostname.split('.')
  if (splitUri[1] === 't') {
    return appENV.test
  }
  if (splitUri[1] === 'd') {
    return appENV.development
  }
  if (splitUri[0] === 'localhost') {
    return appENV.localhost
  }
  return appENV.production
}

const CA_URL_BY_ENV: Record<appENV, string> = {
  [appENV.localhost]: 'https://dev-bo01-ca-02-my-internal.d.tickmill.com',
  [appENV.development]: 'https://dev-bo01-ca-02-my-internal.d.tickmill.com',
  [appENV.test]: 'https://test-bo01-ca-02-my-internal.t.tickmill.com',
  [appENV.production]: 'https://ca-internal.tmill.app',
}

export function getClientAreaUrl(): string {
  if (window.env.APP_CA_URL) return window.env.APP_CA_URL
  return CA_URL_BY_ENV[checkWindowLocation()]
}
